/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ scope: NonNullable<unknown> }} Chat_Tool_Trust_Window_EnableInputs */



/**
* | output |
* | --- |
* | "Trust {scope} for this action" |
*
* @param {Chat_Tool_Trust_Window_EnableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_trust_window_enable = /** @type {((inputs: Chat_Tool_Trust_Window_EnableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Trust_Window_EnableInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.scope} für diese Aktion vertrauen`)
	return /** @type {LocalizedString} */ (`Trust ${i?.scope} for this action`)
});